const getters = {
  device: state => state.app.device,
  showMobileStatus: state => state.app.showMobileStatus,
  showRegisterStatus: state => state.app.showRegisterStatus,
  id: state => state.user.id,
  userId: state => state.user.id,
  memberLevel: state => state.user.memberLevel,
  userPhone: state => state.user.userPhone,
  nickname: state => state.user.nickname,
  userType: state => state.user.userType,
  channelArr: state => state.industry.channelArr,
  channelType: state => state.industry.channelType,
  channelName: state => state.industry.channelName,
  queryType: state => state.industry.queryType,
  queryValue: state => state.industry.queryValue,
  findValue: state => state.industry.findValue
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js